import React from 'react';
import styles from './builder.module.scss';

function Error(props) {
  return <div className={props.children ? styles['error-wrapper'] : 'hidden'}>
    <span className={styles['errorText']}>{props.children}</span>
  </div>;
}
export default Error;
